import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  reportStatsApiService,
  type ReportStatsResponse,
} from "@/generated/fastapi";

export async function reportStats(
  accessToken: string | null | undefined,
) : Promise<ReportStatsResponse> {
  const response = await reportStatsApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
  });

  if (response.status !== 200 || !response.data) {
    throw new Error("Unable to load stats");
  }

  return response.data;
}
